// phonics_data_lt07.js
// Letter Teams L7 - L7 Blends sp, sl, st
// 路由：/phonics/lt07

const MEDIA_BASE = '/media/phonics/lt07';
const V = 'v1';

export const letterDataLt07 = {
  id: 'lt07',
  letter: 'L7',
  title: 'L7 Blends sp, sl, st',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "Four pals are on the ice. They skate.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "Pink does a spin.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Come on!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Skate with us!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Yellow steps on the ice.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "But she slips!", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "I do not like to skate.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "We can ride a sled.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "The pals go up the slope.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "They find a sled with spots.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "They ride down the slope.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "This is not fun!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Stop!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "There's a stone!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "The sled spins.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Four pals fly off!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Yellow smiles.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "That was fun!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
      ],
    },
  ],
};
